// Phone-frame preview. Renders a pre-built mock tree (built in DesignerPage with
// the mock kit, so token-usage + highlight are tracked there). Highlight glow and
// live colors come from the kit; this component is just the frame.
export function MockPreview({ tree, pageLabel }) {
  return (
    <div>
      <div style={{ fontSize: 12, textTransform: "uppercase", letterSpacing: "0.05em", color: "rgba(255,255,255,0.55)", marginBottom: 6 }}>
        Preview{pageLabel ? ` — ${pageLabel}` : ""}
      </div>
      <div style={frame}>
        <div style={screen}>{tree}</div>
      </div>
      <div style={{ fontSize: 11, color: "rgba(255,255,255,0.45)", marginTop: 6 }}>
        Hover a color row to highlight where it's used. Pick a surface in Pages to preview it.
      </div>
    </div>
  );
}

const frame = {
  width: 300,
  border: "10px solid #222",
  borderRadius: 28,
  overflow: "hidden",
  // Ring keeps the dark bezel legible against the dark designer sheet.
  boxShadow: "0 0 0 1px rgba(255,255,255,0.18), 0 6px 24px rgba(0,0,0,0.4)",
  background: "#222",
};
const screen = { width: "100%", aspectRatio: "9 / 17", overflow: "hidden" };
